import { localStorageApi } from '../localStorageApi'

const DesktopMode = {
	CASH_REGISTER: 'CASH_REGISTER',
	KIOSK: 'KIOSK',
}

export const MOBILE_APP_MODE = 'LIEFERSOFT_POS_APP'

export const isCashRegisterMode = (desktopMode) => {
	return desktopMode === DesktopMode.CASH_REGISTER
}

export const isLocalStorageCashRegisterMode = () => {
	const desktopMode = localStorageApi.getItem('desktopMode')
	return desktopMode === DesktopMode.CASH_REGISTER
}

export const isMobileAppMode = (appMode) => {
	return appMode === MOBILE_APP_MODE
}

export const isLocalStorageMobileAppMode = () => {
	const appMode = localStorageApi.getItem('appMode')
	return isMobileAppMode(appMode)
}

export const isClientMonitorEligibleMode = () => {
	return isLocalStorageCashRegisterMode() || isLocalStorageMobileAppMode()
}

const STALE_CREDENTIALS_PROTOCOL_STORAGE_KEY = 'credentialsProtocol'

export const removeStaleCredentialsProtocolFlag = () => {
	localStorageApi.removeItem(STALE_CREDENTIALS_PROTOCOL_STORAGE_KEY)
}
